<template>
  <div v-if="isVisible" class="custom-modal-overlay">
    <div
      class="alert alert-danger"
      role="alert"
      style="position: absolute; top: 30px"
      v-if="error === true"
    >
      {{ errorMsg }}
    </div>
    <div>
      <div v-if="currentPage === 0" class="custom-modal-container">
        <button @click="closeCreateModal" class="close-button">
          <img src="@/assets/img/close.svg" alt="" />
        </button>
        <div class="custom-modal-header">
          <h2>NO VIRTUAL ACCOUNT YET</h2>
        </div>

        <p>
          You haven’t created a virtual account. Virtual accounts let you
          receive payments seamlessly and track transactions with ease.
        </p>
        <button
          class="btn btn-info w-100 text-uppercase"
          @click="createVirtualAccount"
        >
          Create Virtual Account
        </button>
      </div>

      <div v-if="currentPage === 1" class="custom-modal-container">
        <h2>ACCOUNT DETAILS</h2>

        <div class="accountDetail">
          <label>Bank Name</label>
          <p>{{ accountDetails.bankName || accounts[0].bankName }}</p>
        </div>

        <div class="accountDetail">
          <label>Account Number</label>
          <p>{{ accountDetails.accountNumber || accounts[0].accountNumber }}</p>
        </div>

        <div class="accountDetail">
          <label>Account Name</label>
          <p>{{ accountDetails.accountName || accounts[0].accountName }}</p>
        </div>

        <div class="accountDetail">
          <label>Date Created</label>
          <p>
            {{ formatDate(accountDetails.createdAt || accounts[0].createdAt) }}
          </p>
        </div>

        <p>
          An account number will be generated for you to directly transfer money
          to your business. You can deactivate this account anytime in the
          future.
        </p>

        <button
          class="btn btn-info w-100 text-uppercase"
          @click="closeCreateModal"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "../../store/axios";
import { mapActions } from "vuex";
import { error } from "jquery";

export default {
  props: {
    terminalDetails: {
      type: Object,
      required: true,
    },

    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      error: false,
      errorMsg: "",
      currentPage: 0,
      accountDetails: {},
      accounts: [],
    };
  },

  methods: {
    ...mapActions(["setNotification"]),
    closeCreateModal() {
      this.$emit("close");
    },

    async createVirtualAccount() {
      const terminalFullName = this.terminalDetails.tmsMerchantId.merchantName;
      const [terminalFirstName, terminalLastName] = terminalFullName.split(" ");

      const payload = {
        firstName: terminalFirstName,
        lastName: terminalLastName || "",
        email: this.terminalDetails.tmsMerchantId.email,
        phoneNumber: this.terminalDetails.tmsMerchantId.phoneNumber,
        terminalId: this.terminalDetails.terminalId,
      };
      console.log("payload", payload);

      try {
        this.loading = true;
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/merchant/virtual-account/create`,
          payload,
        );

        this.accountDetails = res.data.accountDetails;

        if (res.data.status === "success") {
          this.currentPage = 1;
        } else {
          this.setNotification({
            type: "danger",
            message: res.data.message,
          });
        }
      } catch (err) {
        // this.error = true;
        // this.errorMsg =
        //   "A virtual account cannot be created for this terminal because the TID is invalid.";
        const backendMsg =
          err.response.data.message ||
          err.response.data.error ||
          err.message ||
          "An unexpected error occurred.";

        this.errorMsg = backendMsg;

        this.setNotification({
          type: "danger",
          message: backendMsg,
        });
      }
    },

    formatDate(date) {
      return moment(date).format("MMMM D, YYYY");
    },

    async fetchAccounts(terminalId) {
      try {
        this.loading = true;
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/terminals/linked-account`,
          {
            terminalId: this.terminalDetails.terminalId,
          },
        );

        this.accounts = res.data.accounts;

        if (this.accounts.length === 0 || !res.data.accounts) {
          this.currentPage = 0;
        } else {
          this.currentPage = 1;
        }
      } catch (err) {
        console.log(err);
        this.error = true;

        this.errorMsg = "Unable to Fetch Virtual Accounts";
      }
    },
  },

  watch: {
    terminalDetails: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.terminalId) {
          this.fetchAccounts(newVal.terminalId);
        }
      },
    },
  },
};
</script>

<style scoped>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  max-width: 465px;
  overflow: hidden;
  overflow-y: auto;
  max-height: 100vh;
  padding: 20px;
  text-align: center;
  color: #23242f;
}

.close-button {
  display: flex;
  width: 100%;
  justify-content: end;
}

.close-button {
  border: none;
  background: none;
}

.custom-modal-container h2 {
  font-size: 20px;
  font-weight: 700;
}

.custom-modal-container p {
  margin: 36px 0;
}

.accountDetail {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 2px;
  margin-bottom: 20px;
}

.accountDetail label {
  font-size: 14px;
}

.accountDetail p {
  margin: 0;
  background: #e3e3e3;
  color: #66615c;
  border-radius: 4px;
  padding: 12px 8px;
}
</style>
